import React, { useEffect, useRef } from "react";
import { useAudio } from "../../context/AudioContext";

const AudioWrapper = () => {
  const audioContext = useAudio();
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef != null) {
      audioContext.setAudioRef(audioRef);
    }
  }, []);

  useEffect(() => {
    const handleEnded = () => {
        audioContext.pauseAudio();
    };

    audioRef.current.addEventListener("ended", handleEnded);

    return () => {
      audioRef.current.removeEventListener("ended", handleEnded);
    };
  }, [audioContext.audioRef, audioContext.playNextTrack])

  return (
    <>
      <audio
        ref={audioRef}
        src={audioContext.audioUrl}
      ></audio>
    </>
  );
};

export default AudioWrapper;
